function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusPersonagreement = function SvgPlusPersonagreement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200.53 186.87"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.31 126.12h39.36c3.41 0 6.18 2.77 6.18 6.18v26.27h-51.71V132.3c0-3.41 2.77-6.18 6.18-6.18Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "4.08px",
      stroke: "#00db33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.82 50.93V10.95C48.82 6.01 52 2 55.91 2h135.52c3.91 0 7.09 4 7.09 8.94V149.6c0 4.95-3.18 8.96-7.1 8.96h-85.97",
    style: {
      strokeLinecap: "round",
      stroke: "#007533",
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.98 93.15c0 16.21-11.25 26.28-25.13 26.28s-25.13-11.76-25.13-26.28 11.25-26.28 25.13-26.28 25.13 11.76 25.13 26.28Z",
    style: {
      stroke: "#007533",
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96 184.83h80.8c5.22 0 8.2-7.04 5.07-11.97l-16.94-36.94c-1.75-2.76-4.5-4.38-7.42-4.38l-43.43-.78c-2.91 0-5.58 1.94-6.88 5.02L2.67 174.72c-1.97 4.64.89 10.11 5.29 10.11Z",
    style: {
      stroke: "#007533",
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "4.08px"
    }
  })));
};
export default SvgPlusPersonagreement;